(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name consult.factory:ConsultHelper
   *
   * @description
   *
   */
  angular
    .module('vcconsult')
    .factory('ConsultHelper', ConsultHelper);


  ConsultHelper.$inject = ['Consult', '$uibModal', '$log', 'Rlog'];

  function ConsultHelper(Consult, $uibModal, $log, Rlog) {
    let ConsultHelperBase = {};

    ConsultHelperBase.editConsult = editConsult;
    ConsultHelperBase.addConsult = addConsult;
    ConsultHelperBase.closeConsultModal = closeConsultModal;


    // function closeConsultModal(lclientid, ldiagnoses, ltest, lconsultid) {
    function closeConsultModal(lconsult, ldiagnoses, ltest, lfinish) {
      $log.debug('ConsultHelper.closeConsultModal  called');
      let dialog = $uibModal.open({
        template: `
          <div class="modalspacer">
            <carteditor clientid="vm.clientid"  diagnoses="vm.diagnoses" test="vm.test" ng-hide="vm.started"></carteditor>
              
            <form name="payment" ng-hide="vm.started">
              <div class="spacer-top">
                <div class="alert alert-warning" ng-show="vm.itemsnum > 0">
                    <h4>Bezahlmethode</h4>
                    <label><input type="radio" ng-model="vm.paytype" value="cash" required> Bar</label>
                    <label><input type="radio" ng-model="vm.paytype" value="card" required> Bankomat o. Kreditkarte</label>
                    <label><input type="radio" ng-model="vm.paytype" value="bill" required> Rechnung mit Zahlschein</label>
                </div>
              </div>
            
            <!-- Buttons -->
              <div class="spacer-top">
                <p class="spacer-bottom">
                  <input type="checkbox" id="nofindings" ng-model="vm.nofindings" data-hook="no_findings"> Keinen Gesamtbefund erstellen
                </p>
                <div class="btn btn-success" ng-click="vm.closeInvoiceConsult(vm.consultid)"  data-hook="closeconsult_with_invoice" ng-show="vm.itemsnum > 0" ng-disabled="payment.$invalid">
                  <i class="fa fa-money"></i> Rechnung austellen und Konsultation abschließen
                </div>
                <p>
                  <div class="btn btn-warning" ng-click="vm.closeConsult(vm.consultid)" data-hook="closeconsult_no_invoice"><i class="fa fa-sign-out"></i> Konsultation ohne Rechnung abschließen
                  <sprhelp tip="Keine Rechnung" descref="vm.consultnoinvoicehelp"></sprhelp></div>
                    
                  <div class="btn btn-danger" ng-click="vm.confirm = true;" ng-hide="vm.confirm"><i class="fa fa-remove"></i> Konsultation beenden und löschen
                  <sprhelp tip="Ganz weg damit!" descref="vm.consultdeletehelp"></sprhelp></div>
                    
                  <div class="alert alert-danger" ng-show="vm.confirm">
                  <h3>Konsultation löschen</h3>
                  <p ng-bind="vm.consultdeletehelp"></p>
                  <p>Schreiben Sie: "Weg damit!" in das Eingabefeld</p>
                  <div class="spacer-bottom spacer-top">
                    <input type="text" ng-model="vm.confirmDelete" class="form-control">
                  </div>
                  <div class="spacer-bottom spacer-top">
                    <button ng-click="vm.deleteConsult(vm.consultid)"  data-hook="deleteconsult" class="btn btn-danger">Konsultation beenden und löschen</button>
                  </div>
                  </div>
                
                </p>
              </div>
              </form>
              
              <!-- Dokumentgenerierung und Anzeige -->
              <div class="spacer-top">
                <div ng-show="vm.started">
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <h4>Dokumente</h4>
                      <div class="alert alert-info" ng-show="vm.doccount">
                          <h4><i class="fa fa-spinner fa-spin"></i> {{vm.doccount}} Dokumente werden erstellt!</h4>
                      </div>
                      <div ng-repeat="doc in vm.docs"  data-hook="consult_documents">
                        <a href="/routes/pdfreader/{{doc.fileid}}" target="_blank">
                          <span class="fa fa-file-pdf-o"></span> {{doc.type}}
                        </a>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6" ng-show="vm.invstarted">
                      <h4>Rechnungen/Beleg</h4>
                      <div class="alert alert-info" ng-show="vm.invcount">
                          <h4><i class="fa fa-spinner fa-spin"></i> {{vm.invcount}} Rechnungsdokumente werden erstellt!</h4>
                      </div>
                      <div ng-repeat="doc in vm.invdocs"  data-hook="consult_financial_documents">
                        <a href="/routes/pdfreader/{{doc.fileid}}" target="_blank">
                          <span class="fa fa-file-pdf-o"></span> {{doc.type}}
                        </a>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <!-- Buttons -->
              <div class="spacer-top"  ng-show="(vm.invcount === 0 && vm.doccount === 0) || (!vm.invcount && vm.doccount === 0)">
                <div class="row">
                  <div class="col-xs-12">
                    <span class="btn btn-success" ng-click="vm.localfinish(vm.docs, vm.invdocs)"  data-hook="closeconsult_no_documents">
                        <i class="fa fa-sign-out"></i> Konsultation abschließen
                    </span>
                  </div>
                </div>
              </div>
               <div class="spacer-top"  ng-show="vm.timeout === true && (vm.invcount > 0 || vm.invdocs > 0)">
                <div class="row">
                  <div class="col-xs-12">
                    <span class="btn btn-warning" ng-click="vm.localfinish(vm.docs, vm.invdocs)" data-hook="closeconsult_no_documents">
                        <i class="fa fa-sign-out"></i> Konsultation ohne Dokumente abschließen
                    </span>
                  </div>
                </div>
              </div>
          </div>
`,
        controllerAs: 'vm',
        controller: ['sconsult', 'PrintHelper', '$scope', 'sdiagnoses', 'stest', '$rootScope', '$http', 'sfinish', '$timeout', 'Cart', 'vertxEventBusService',
          function (sconsult, PrintHelper, $scope, sdiagnoses, stest, $rootScope, $http, sfinish, $timeout, Cart, vertxEventBusService) {
            let vm = this;

            vm.consult = sconsult;
            // vm.finish = sfinish;
            vm.localfinish = localfinish;
            vm.clientid = vm.consult.patientid;
            vm.diagnoses = sdiagnoses;
            vm.test = stest;
            vm.$scope = $scope;
            vm.$rootscope = $rootScope;

            vm.consultdeletehelp = `Benutzen Sie diese Option nur, falls Sie versehentlich eine Konsultation gestartet haben. 
              Es werden keine Dokumente erstellt oder gedruckt. Die Konsultation erscheint auch nicht in der Historie.`;
            vm.consultnoinvoicehelp = `Befunde, Verordnungen und Uberweisungen werden gedruckt. Es wird keine Rechnung erstellt. 
              Bestehende Rechnungspositionen verbleiben im Warenkorb.`;

            $log.debug('consultHelper controller  called for consultid: ', vm.consult._id);

            vm.consult.examinations.$refresh().$then(function () {
              $log.debug('exam refresh succcess');
            }, function (e) {
              $log.debug('exam refresh failure ', e);
            });

            vm.cancel = cancel;
            // vm.closeConsult = scloseConsult;
            vm.closeInvoiceConsult = closeInvoiceConsult;
            vm.closeConsult = closeConsult;
            vm.deleteConsult = deleteConsult;


            vm.$onInit = function () {
              Cart.getCount(vm.clientid).then(res => {
                vm.itemsnum = 0;
                // $log.debug('**** cart Counter data: ', res.data);
                vm.itemsnum = res.data.count;
              }, err => {
                $log.error('vcconsult consulthelper counter aquisition  failed: ', err);
                Rlog.error('vcconsult', 'consulthelper', 'counter aquisition  failed', {});
              });
            };

            function localfinish(docs, invdocs) {
              $log.debug(' ### consulthelper localfinish called, now calling sfinish with: ', docs, invdocs);
              sfinish(docs, invdocs);
              dialog.close();
            }

            function cancel() {
              dialog.close();
            }

            function closeInvoiceConsult(consultid) {

              // after 2minutes show force=consult-close button
              $timeout(function () {
                vm.timeout = true;
              }, 120000);
              vm.invstarted = true;
              vm.invdocs = [];
              $log.debug('closeInvoiceConsult called for: ', consultid);

              if (vm.paytype === 'cash' || vm.paytype === 'card') {
                vm.invcount = 3;
                $http.post(`/routes/cashinvoices/${vm.consult.patientid}/${vm.paytype}/${vm.consult._id}`)
                  .then(
                    function (inv) {
                      $log.debug('cash inv answer: ', inv);

                      vm.invdocs.push({type: 'Rechnung (Patientenkopie)', fileid: inv.data.patientinvoiceid});
                      vm.invdocs.push({type: 'Rechnung (Arztkopie)', fileid: inv.data.doctorinvoiceid});
                      if (angular.isDefined(inv.data.doctorinvoiceid) && inv.data.doctorinvoiceid.length > 0) {
                        vm.invdocs.push({type: 'Beleg', fileid: inv.data.receiptid});
                      }
                      $http.post(`/routes/carts/${vm.clientid}/closecart`).then(function () {
                        $log.debug('Cart close succeeded');
                      }, function (err) {
                        $log.error('Cart close failed', err);
                      });
                      vm.invcount = 0;
                    },
                    function (error) {
                      $log.error('CashinvoicePrintfailed: ', error);
                      $rootScope.connfailure = 0;
                      vm.invdocs.push({type: 'Rechnung fehlgeschlagen', fileid: ''});
                      vm.invcount = 0;
                    });
              }

              if (vm.paytype === 'bill') {
                vm.invcount = 2;
                $http.post(`/routes/checkinvoices/${vm.consult.patientid}/${vm.consult._id}`)
                  .then(
                    function (inv) {
                      vm.invdocs.push({type: 'Rechnung (Patientenkopie)', fileid: inv.data.patientinvoiceid});
                      vm.invdocs.push({type: 'Rechnung (Arztkopie)', fileid: inv.data.doctorinvoiceid});
                      $http.post(`/routes/carts/${vm.clientid}/closecart`).then(function () {
                        $log.debug('Cart close succeeded');
                      }, function (err) {
                        $log.error('Cart close failed', err);
                      });
                      vm.invcount = 0;
                    },
                    function (error) {
                      $log.error('CheckinvoicePrintfailed: ', error);
                      $rootScope.connfailure = 0;
                      vm.invdocs.push({type: 'Rechnung fehlgeschlagen', fileid: ''});
                      vm.invcount = 0;
                    });
              }
              $timeout(function () {
                closeConsult();
              }, 500);

            }


            function closeConsult() {
              $log.debug('###################   closeConsult started');
              vm.started = true;
              vm.docs = [];
              vm.doccount = 0;

              vm.consult.examlabelsPrimary = [];
              vm.consult.examlabelsSecondary = [];


              // Gesamtbefund
              if (!vm.nofindings === true) {
                vm.doccount++;
                PrintHelper.consultPrint(vm.consult._id).then(function (doc) {
                  vm.docs.push({type: 'Gesamtbefund', fileid: doc.data.docid});
                  vm.doccount--;
                  $rootScope.connfailure = 0;
                }, function (error) {
                  $log.error('ConsultPrintfailed: ', error);
                  vm.doccount--;
                  $rootScope.connfailure = 0;
                  vm.docs.push({type: 'Gesamtbefund fehlgeschlagen', fileid: ''});
                });
              }

              // print referrals
              getCounter('referral', vm.consult._id).then(res => {
                if (res.data.counter && res.data.counter > 0) {
                  vm.doccount++;
                  printReferral();
                }
              }, err => {
                Rlog.error('consulthelper', 'refcounter', 'refcounter.$aggregate failed', {});
                $log.error('consulthelper, refcounter refcounter.$aggregate failed: ', err);
              });


              // print aides (Hilfsmittelverordnung)
              getCounter('aide', vm.consult._id).then(res => {
                if (res.data.counter && res.data.counter > 0) {
                  vm.doccount++;
                  printAide();
                }
              }, err => {
                Rlog.error('consulthelper', 'aidecoutner', 'aidecounter.$aggregate failed', {});
                $log.error('consulthelper, aidecoutner refcounter.$aggregate failed: ', err);
              });


              // print or persist exams depending on settings
              // never persist or print status finding included in general findings report
              vm.consult.examinations.map(function (exam) {
                $log.debug('consult helper factory consult examination loop: ', exam);
                if (exam.active && exam.print && !exam.template.includefindings === true) {
                  vm.doccount++;
                  // persistExam(exam); // TODO switch back to printExam after test
                  printExam(exam);
                }

                if (exam.active && !exam.print && !exam.template.includefindings === true) {
                  vm.doccount++;
                  persistExam(exam);
                }

              });

              // add exam labels and pdf docids to consult record

/*              vm.consult.examinations.map(function (exam) {

                if (exam.active && exam.template.includefindings !== true) {
                  vm.consult.examlabelsPrimary.push({type: exam.template.displayname});
                } else {
                  vm.consult.examlabelsSecondary.push({type: exam.template.displayname});
                }
              });

              vm.consult.$save().$then(function () {
              }, function (err) {
                $log.error(' ### saving of consult failed after adding examlabels: ', err);
                Rlog.error('vcutils.consult', 'consult helper factory', 'Saving of consult failed after adding exam labels on finish: ', {
                  consultid: vm.consult._id
                });
              });*/

            }

            function deleteConsult() {
              $log.debug('really delete: ', vm.confirmDelete, vm.confirmDelete === 'Weg damit!');
              if (vm.confirmDelete === 'Weg damit!') {
                vm.consult.active = false;
                vm.localfinish([], []);
                $log.debug('###################   deleteConsult started, set active to false');
                vm.started = true;
                vm.docs = [];
                vm.doccount = 0;
              } else {
                delete vm.confirm;
                delete vm.confirmDelete;
              }

            }


            function printExam(exam) {
              $log.debug('exam in printExam: ', exam);

              PrintHelper.examPrint(exam._id, exam.consultid).then(function (doc) {
                vm.docs.push({type: 'Untersuchungsbefund ' + exam.type, fileid: doc.data.docid, examid: exam._id});
                if (exam.active && exam.template.includefindings !== true) {
                  vm.consult.examlabelsPrimary.push({type: exam.template.displayname, docid: doc.data.docid});
                } else {
                  vm.consult.examlabelsSecondary.push({type: exam.template.displayname});
                }

                exam.docid = doc.data.docid;
                exam.$save().$then(()=> $log.debug('docid saved to exam: ', exam._id ),
                  (err) => $log.error('saving docid to exam failed: ', exam._id, err));

                vm.doccount--;
                $rootScope.connfailure = 0;
              }, function (error) {
                $log.error('Failed: Untersuchungsbefund print for: ', exam.type, error);
                vm.doccount--;
                $rootScope.connfailure = 0;
                vm.docs.push({type: 'Untersuchungsbefund ' + exam.type + ' fehlgeschlagen', fileid: ''});
              });
            }

            function persistExam(exam) {
              PrintHelper.examPersist(exam._id, exam.consultid).then(function (doc) {
                vm.docs.push({type: 'Untersuchungsbefund ' + exam.type, fileid: doc.data.docid, examid: exam._id});
                if (exam.active && exam.template.includefindings !== true) {
                  vm.consult.examlabelsPrimary.push({type: exam.template.displayname, docid: doc.data.docid});
                } else {
                  vm.consult.examlabelsSecondary.push({type: exam.template.displayname});
                }
                exam.docid = doc.data.docid;
                exam.$save().$then(()=> $log.debug('docid saved to exam: ', exam._id ),
                  (err) => $log.error('savind docid to exam failed: ', exam._id, err));

                vm.doccount--;
                $rootScope.connfailure = 0;
                $log.debug('doccount : ', vm.doccount);
              }, function (error) {
                $log.error('Failed: Untersuchungsbefund persist for: ', exam.type, error);
                vm.doccount--;
                $rootScope.connfailure = 0;
                $log.debug('doccount : ', vm.doccount);
                vm.docs.push({type: 'Untersuchungsbefund ' + exam.type + ' fehlgeschlagen', fileid: ''});
              });
            }

            function printAide() {
              // TODO: switch Persist back to Print
              PrintHelper.aidePrint(vm.consult.patientid, vm.consult._id).then(function (doc) {
                vm.docs.push({type: 'Hilsmittel-Verordnung(en)', fileid: doc.data.docid});
                vm.doccount--;
                $rootScope.connfailure = 0;
              }, function (error) {
                $log.error('AidePrintfailed: ', error);
                vm.doccount--;
                $rootScope.connfailure = 0;
                vm.docs.push({type: 'Hilsmittelverordnung fehlgeschlagen', fileid: ''});
              });
            }

            function printReferral() {
              // TODO: switch Persist back to Print
              PrintHelper.referralPrint(vm.consult.patientid, vm.consult._id).then(function (doc) {
                vm.docs.push({type: 'Überweisung(en)', fileid: doc.data.docid});
                vm.doccount--;
                $rootScope.connfailure = 0;
              }, function (error) {
                $log.error('ReferralPrintfailed: ', error);
                vm.doccount--;
                $rootScope.connfailure = 0;
                vm.docs.push({type: 'Überweisung fehlgeschlagen', fileid: ''});
              });
            }

            function getCounter(type, consultid) {
              let query = [{
                $match: {
                  consultid: consultid,
                  type: type,
                  active: true
                }
              }, {
                $group: {
                  _id: 'counter',
                  counter: {$sum: 1}
                }
              }];

              return $http.post('/routes/patdocs/aggregate', query);
            }

            vertxEventBusService.on('carts.update', function (message) {
              let messages = message.split(':');
              Cart.getCount(vm.clientid).then(res => {
                vm.itemsnum = res.data.count;
              }, err => {
                $log.error('vcconsult consulthelper cart counter aquisition  failed: ', err);
                Rlog.error('vcconsult', 'consulthelper', 'caet counter aquisition  failed', {});
              });
              $log.debug('(checkout screen) refreshed cart');
            });

          }],
        resolve: {
          sconsult: function () {
            return lconsult;
          },
          sfinish: function () {
            return lfinish;
          },
          stest: function () {
            return ltest;
          },
          sdiagnoses: function () {

            if (angular.isArray(ldiagnoses) && ldiagnoses.length > 0) {
              let flatdiagnosesarr = [];
              ldiagnoses.map(function (d) {
                flatdiagnosesarr.push(d.key);
              });
              return flatdiagnosesarr.join(', ');
            } else {
              return '';
            }

          }
        },
        size: 'lg'
      });
      return dialog;
    }


    function addConsult(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><consultform consult="consultaCtrl.consult" parentsave="consultaCtrl.childsave(consult)" oncancel="consultaCtrl.cancel()"></consultnew></div>',
        controllerAs: 'consultaCtrl',
        controller: ['consult', function () {
          let vm = this;
          vm.consult = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(consult) {
            Consult.$create(consult).$then(function (newconsult) {
              vm.created = true;
              success(newconsult);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ consult-helper.addConsult: ', err);
              Rlog.error('vcutils.consult', 'consult-helper.addConsult', 'Creation of new SV failed: ', {
                consultid: consult._id
              });
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }

        }],
        resolve: {
          consult: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }


    function editConsult(lconsult) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><consultform consult="consulteCtrl.consult" parentsave="consulteCtrl.childsave(consult)" oncancel="consulteCtrl.cancel()"></consultform></div>',
        controllerAs: 'consulteCtrl',
        controller: ['consult', '$timeout', function (sconsult, $timeout) {
          let vm = this;
          vm.consult = sconsult;
          vm.childsave = childsave;
          vm.cancel = cancel;


          function childsave(consult) {
            // vm.consult = angular.copy(consult);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in consult) {
              if (consult.hasOwnProperty(key)) {
                vm.consult[key] = consult[key];
              }
            }

            if (vm.consult.$hasPendingActions) {
              $log.warn('[CONSULT][HELPER] consult save had pending actions, cancelling now.');

              vm.consult.$cancel();
              $timeout(function () {
                $log.warn('[CONSULT][HELPER]  waited 1.5 seconds because of consult having had pending actions, saving now.');
                savesave();
                dialog.close();
              }, 1500);
            } else {
              savesave();
              dialog.close();
            }
          }

          function savesave() {
            vm.consult.$save().$then(function () {
            }, function (err) {
              $log.error('[CLIENT][PatientHeader] client save failed!', err);
              Rlog.error('client', 'clienteditor', 'client.$save() failed', {id: vm.client._id});
            });
          }

          function cancel() {
            dialog.close();
          }


        }],
        resolve: {
          consult: function () {
            return lconsult;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return ConsultHelperBase;
  }
}());
